// A simple audio context singleton
let audioContext: AudioContext;

export const getAudioContext = (): AudioContext => {
  if (typeof window !== 'undefined' && !audioContext) {
    audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
  }
  return audioContext;
};

// Master gain all Editor-triggered sounds route through, so the Editor can be silenced as a
// whole (e.g. while the Piano Rec/DAW, which shares this same AudioContext, is open) without
// touching individually-scheduled oscillators.
let editorMasterGain: GainNode | null = null;

export const getEditorMasterGain = (): GainNode => {
  const ctx = getAudioContext();
  if (!editorMasterGain) {
    editorMasterGain = ctx.createGain();
    editorMasterGain.gain.setValueAtTime(1, ctx.currentTime);
    editorMasterGain.connect(ctx.destination);
  }
  return editorMasterGain;
};

export const muteEditorAudio = (): void => {
  const ctx = getAudioContext();
  const gain = getEditorMasterGain();
  gain.gain.cancelScheduledValues(ctx.currentTime);
  gain.gain.setValueAtTime(0, ctx.currentTime);
};

export const unmuteEditorAudio = (): void => {
  const ctx = getAudioContext();
  const gain = getEditorMasterGain();
  gain.gain.cancelScheduledValues(ctx.currentTime);
  gain.gain.setValueAtTime(1, ctx.currentTime);
};
